import { AddDays } from '../../utils/date-helper';
import { CreditAction, CreditType, LoanType } from './credit-report-transaction';

export enum CreditBureau {
  Experian = 'Experian',
  Equifax = 'Equifax',
  TransUnion = 'TransUnion',
}

export interface Borrower {
  borrowerId?: string;
  firstName?: string;
  lastName?: string;
  ssn?: string;
  dateOfBirth?: Date;
  currentAddress?: Address;
}

export const defaultBorrower: Borrower = {
  borrowerId: '',
  firstName: '',
  lastName: '',
  ssn: '',
  dateOfBirth: AddDays(new Date(), -1),
  currentAddress: undefined,
};

export interface Credit {
  creditAction?: CreditAction;
  creditType?: CreditType;
  creditBureaus?: CreditBureau[];
  creditReferenceNumber?: string;
  creditReportingAgency?: string;
}

export interface CreditReportRequest {
  vendor?: string;
  credit?: Credit;
  loan?: Loan;
  borrowers?: Borrower[];
  includes?: string[];
  testCase?: Borrower[];
}

export const createDefaultCreditReportRequest = (): CreditReportRequest => ({
  vendor: undefined,
  credit: {
    creditAction: CreditAction.Submit,
    creditType: CreditType.Soft,
    creditBureaus: [CreditBureau.Experian, CreditBureau.Equifax, CreditBureau.TransUnion],
  },
  loan: {
    lenderLoanNumber: undefined,
    loanType: undefined,
  },
  borrowers: [
    {
      borrowerId: '',
      firstName: '',
      lastName: '',
      ssn: '',
      dateOfBirth: AddDays(new Date(), -1),
      currentAddress: undefined,
    },
  ],
  includes: [],
});

export interface Loan {
  lenderLoanNumber?: string;
  loanType?: LoanType;
}

export interface Address {
  address1?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}
